import { defineTheme } from '../utils'

export const marinaLoungeNew = defineTheme({
  allergiesList: {
    filterLink: 'text-tertiary',
  },
  languageButton: {
    base: 'rounded-sm bg-white p-2.5 text-sm text-black',
  },
  menuCategory: {
    title: 'mb-4 border-b-2 border-secondary pb-2 text-center font-heading text-4xl font-semibold uppercase',
    description: 'text-white',
  },
  menuItem: {
    dinner: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'font-bold',
      description: 'order-2 col-span-2 text-sm',
      priceList: 'text-right text-tertiary',
      icons: 'order-4 col-span-2',
      label: 'order-3 col-span-2 mb-1 bg-quarternary p-2 font-base text-sm font-medium text-black',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-x-2',
      title: 'font-bold',
      description: 'col-span-2 text-sm',
      priceList: 'text-right text-tertiary',
      icons: 'order-3 col-span-2',
      label: 'order-3 col-span-2 mb-1 bg-quarternary p-2 font-base text-sm font-medium text-black',
    },
  },
  menuSubCategory: {
    title: 'mb-1 font-bold text-tertiary',
  },
  menuTextBlock: {
    base: 'border-3 p-4',
  },
  menuTitleBlock: {
    title: 'text-center font-heading text-7xl text-font-primary uppercase',
  },
  page: {
    heading: 'font-heading text-7xl text-font-primary uppercase',
    menuHeading: 'mb-10 text-center font-heading text-7xl uppercase',
  },
  themeLogo: {
    image: 'h-50 w-50 bg-[url(/images/logos/marina-lounge.png)] bg-contain bg-center bg-no-repeat object-contain',
  },
  filterBar: {
    bar: 'bg-tertiary text-white',
    checkbox: ' accent-white',
    closeButton: 'bg-primary hover:bg-primary/60',
    masterItem: 'text-black',
    itemLabel: 'text-white',
    popoverTitle: 'text-white',
    popover: 'bg-primary',
    popoverHeader: 'bg-tertiary',
    groupLabel: 'text-white',
    allergenInfo: 'text-white',
    resetButton: 'w-full cursor-pointer rounded-lg border border-white/20 bg-transparent py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-white/5',
    applyButton: 'w-full cursor-pointer rounded-lg bg-white py-3 text-center text-sm font-semibold text-black transition-colors hover:bg-white/80',
  },
})
